import { lazy } from 'react';
import { Route } from 'react-router-dom';
import { key } from './config';

const List = lazy(() => import('./index'));
const Create = lazy(() => import('./create'));
const Update = lazy(() => import('./update'));
const Batch = lazy(() => import('./batch'));

export default function PaymentRoutes() {
  return (
    <Route path={key}>
      <Route index element={<List />} />
      <Route path="create" element={<Create />} />
      <Route path=":id/update" element={<Update />} />
      <Route path="batch" element={<Batch />} />
    </Route>
  );
}
